// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticleToolbar-cls1_a30","cls2":"ArticleToolbar-cls2_qMM ArticleToolbar-cls1_a30"};